export const handleIsValidDomain = (domain: string) => {
  const regex = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.[A-Za-z0-9-]{1,63})*$/;
  return regex.test(domain);
};

export const handleIsValidEmail = (email: string) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(email);
};

export function formatDate(tsecs: number | null | undefined): string {
  if (!tsecs) return '—';
  return new Date(tsecs * 1000).toLocaleDateString('en-US', {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatTimestamp(tsecs: number | null | undefined): string {
  if (!tsecs) return '—';
  return new Date(tsecs * 1000).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function tsecsToDayString(tsecs: number | null | undefined): string {
  if (!tsecs) return '';
  const d = new Date(tsecs * 1000);
  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(d.getUTCDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function dayStringToTsecs(s: string): number | null {
  if (!s) return null;
  const ms = Date.parse(s + 'T00:00:00Z');
  return isNaN(ms) ? null : ms / 1000;
}
